module.exports = __webpack_public_path__ + "img/20190524164620QQ截图20190524163230.2335f9aa.png";